var map = {
	"./registration/data-guaranteed.webp": "2957",
	"./registration/email-sent.webp": "94f5",
	"./registration/otp-success.webp": "7587",
	"./registration/quotes-1.webp": "8575",
	"./registration/quotes-2.webp": "5998",
	"./registration/quotes-3.webp": "f60c",
	"./registration/registration-step1.webp": "7237",
	"./registration/registration-success.webp": "ac12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c955";